import { Input, ListGroupItem } from "reactstrap";
import { selectedClasses } from "../list/ClassModifiers";

interface Props<T extends string | number> {
  identifier: T;
  toggleSelection: (identifier: T) => void;
  isSelected: boolean;
}

export function EntryCheckbox<T extends string | number>({
  identifier,
  toggleSelection,
  isSelected,
}: Props<T>) {
  return (
    <ListGroupItem
      active={isSelected}
      className={
        "d-flex with-left-column col-auto fs-4 align-items-center justify-content-center border-0 rounded-0 " +
        selectedClasses(isSelected)
      }
      onClick={() => toggleSelection(identifier)}
    >
      <Input
        type="checkbox"
        className="m-0"
        color="primary"
        checked={isSelected}
        readOnly
      />
    </ListGroupItem>
  );
}
